import type {ProductsState} from './types'
import {type ProductAction, ProductActionType} from '../actions/ProductActions'

const ZERO = 0

export const initialProductsState: ProductsState = {
  pending: false,
  error: '',
  list: {
    inductive: {
      entries: [],
      totalCost: ZERO
    },
    ultrasonic: null
  }
}

export function productReducer(state = initialProductsState, action: ProductAction) {
  if (action.type === ProductActionType.PRODUCT_LIST_PENDING) {
    return {
      ...state,
      pending: true
    }
  }

  if (action.type === ProductActionType.PRODUCT_LIST_FULFILLED) {
    return {
      ...state,
      pending: false,
      list: action.payload,
      error: ''
    }
  }

  if (action.type === ProductActionType.PRODUCT_LIST_REJECTED) {
    return {
      ...state,
      pending: false,
      list: null,
      error: action.payload.error
    }
  }

  return state
}
